const Constants = {
    // baseURL: "http://xmapp.test.zdg.sun0769.com", // 服务器url

    baseURL: "https://appzdg.sun0769.com", // 服务器url
    // baseURL: "https://app.dev.zdg.xinmem.com", // 服务器url


    // testURL: "http://xmapp.test.zdg.sun0769.com", // 服务器url
    testURL: "https://stappzdg.sun0769.com", // 服务器url
    // baseURL: "https://appzdg.sun0769.com", // 服务器url
    downURL: "https://appzdg.sun0769.com/app/index/download",  // 下载地址
    mainURL: "https://appzdg.sun0769.com",  // 页面域名
    // mainURL:"http://xmapp.test.zdg.sun0769.com",
    cookie_key: '_wap-zdg-sessionid'
};

module.exports = Constants;
